import createApi from 'api/createApi';

export const tags = {
	group__all: 'mw/admin/group/all',
};

export const groupApi = createApi({
	reducerPath: 'mw/admin/groupApi',

	endpoints: (builder) => ({
		groupAll: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/group/all',
				body,
				jsonType: true,
			}),
			providesTags: [tags.group__all],
		}),
	}),
});

export const {
	groupAll,
} = groupApi.endpoints;

export default groupApi;
